<style>
</style>

<template>
  <div id="home">
    <span v-show="watercoursesLoadStatus == 1">Henter vassdrag..</span>
    <span v-show="watercoursesLoadStatus == 2">Vassdrag hentet</span>
    <span v-show="watercoursesLoadStatus == 3">Henting av vassdrag feilet!</span>
    <div class="grid-container">
      <div class="grid-x grid-padding-x">
        <loader
          v-show="watercoursesLoadStatus == 1"
          :width="100"
          :height="100"
        ></loader>
        <card
          v-for="watercourse in watercourses"
          :key="watercourse.id"
          :watercourse=watercourse
        ></card>
      </div>
    </div>

  </div>
</template>

<script>
import Loader from "../components/global/Loader.vue";

export default {
  components: {
    Loader
  },
  created() {
    this.$store.dispatch("loadWatercourses");
  },

  computed: {
    watercoursesLoadStatus() {
      return this.$store.getters.getWatercoursesLoadStatus;
    },
    watercourses() {
      return this.$store.getters.getWatercourses;
    }
  }
};
</script>
